var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-loading",
    style: {
      backgroundColor: _vm.backgroundColor,
      opacity: _vm.opacity
    }
  }, [_vm.loadingMessage ? _c('p', {
    staticClass: "text-center loading-text"
  }, [_vm._v(_vm._s(_vm.loadingMessage))]) : _vm._e(), _vm._m(0)]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "lds-ring"
  }, [_c('div'), _c('div'), _c('div'), _c('div')]);
}]

export { render, staticRenderFns }